/* eslint-disable react-hooks/rules-of-hooks */
import { AlreadyPaidOptions } from '../shared/types';
import {
  AppHeaderBackButton,
  Button,
  Typography,
  Form,
  RadioGroup,
  FormTypography,
  useRadioGroupValidator,
  Radio,
  RadioTypography,
  ButtonGroup,
  Box,
} from '@ace-clublabs/shared-component-library';
import { YesNo } from '@ace-clublabs/payments-component-library';

interface Props {
  allowAutoPay: boolean;
  handleBack: () => void;
  handleSubmit: (vals: { alreadyPaid: AlreadyPaidOptions }) => void;
  handleNext: (e: any) => void;
  handleCancel: () => void;
  isMobileApp: boolean;
}

export const AlreadyPaidForm: React.FC<Props> = (props) => {
  const { handleBack, handleSubmit, handleCancel, handleNext, isMobileApp, allowAutoPay } = props;

  const submitOnEnter = (handleSubmit: () => void) => (event: any) => {
    if (event?.key === 'Enter') handleSubmit();
  };

  const headline = allowAutoPay
    ? 'You already paid the amount due. Would you like to do anything else?'
    : `You don't have a payment due. Do you want to make an additional payment?`;

  const options = [
    {
      id: 'pay-additional-amount',
      value: AlreadyPaidOptions.AdditionalPayment,
      header: 'Pay an additional amount',
      display: 'You can either pay a part or all of your remaining premium.',
    },
    {
      id: 'enroll-in-autopay',
      value: AlreadyPaidOptions.EnrollInAutoPay,
      header: 'Enroll in Auto Pay',
      display: 'Your payments will never be late with Auto Pay.',
    },
  ];

  const getOptionsRadios = () => {
    return options.map((option) => (
      <Radio
        key={option.id}
        value={option.value}
        label={
          <>
            <RadioTypography variant="primary" id={`RadioItem-header-${option.id}`}>
              {option.header}
            </RadioTypography>
            <RadioTypography variant="secondary" id={`RadioItem-display-${option.id}`}>
              {option.display}
            </RadioTypography>
          </>
        }
      />
    ));
  };

  return (
    <div id="already-paid-form">
      {!isMobileApp && <AppHeaderBackButton id="back-button" onClick={handleBack} />}
      {allowAutoPay ? (
        <Box className="margin16Bottom margin16Top">
          <Typography variant="h5Medium" id="already-paid-header">
            {headline}
          </Typography>
          <Form onSubmit={handleSubmit}>
            <FormTypography variant="secondary">Select one</FormTypography>
            <RadioGroup name="alreadyPaid" id="alreadyPaidRadio" validator={useRadioGroupValidator()} fullWidth>
              {getOptionsRadios()}
            </RadioGroup>
            <ButtonGroup className="submit-cancel-group">
              <Button variant="contained" id="continue-button" type="submit" label="Continue" />
              <Button variant="outlined" id="cancel-button" onClick={handleCancel} label="Cancel" type="button" />
            </ButtonGroup>
          </Form>
        </Box>
      ) : (
        <Box className="margin16Bottom margin16Top">
          <YesNo title={headline} handleNext={handleNext}></YesNo>
        </Box>
      )}
    </div>
  );
};
